import React from 'react';
import { Coffee, BatteryLow, Brain, Moon } from 'lucide-react';
export function MirrorSection() {
  return <section className="py-4 md:py-14 px-6 bg-background" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-214">
          <div data-id="element-215">
            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-216">
              Sé exactamente lo que se siente.
            </h2>
            <div className="space-y-6 text-lg text-navy/80 leading-relaxed" data-id="element-217">
              <p data-id="element-218">
                Te levantás con el pie izquierdo, te mirás al espejo y{' '}
                <strong className="text-navy" data-id="element-219">no te reconocés</strong>. Sentís
                esa{' '}
                <strong className="text-navy" data-id="element-220">inflamación en la cara</strong>,
                esa{' '}
                <strong className="text-navy" data-id="element-221">pesadez en los párpados</strong>.
              </p>
              <p data-id="element-222">
                Te preparás un café (el tercero del día) solo para poder empezar
                a trabajar. Pero a las 11 AM ya estás{' '}
                <strong className="text-navy" data-id="element-223">buscando algo dulce</strong>. No
                es hambre, es tu{' '}
                <span className="text-accent font-semibold" data-id="element-224">
                  cerebro pidiendo clemencia
                </span>{' '}
                porque <strong className="text-navy" data-id="element-225">se quedó sin nafta</strong>
                .
              </p>
              <p data-id="element-226">
                Llegás a la noche{' '}
                <strong className="text-navy" data-id="element-227">tan agotado</strong> que ni
                siquiera tenés ganas de estar con tu familia. Vivís en{' '}
                <strong className="text-navy" data-id="element-228">piloto automático</strong>.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-229">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-230">
              <BatteryLow className="w-8 h-8 text-accent mb-3" data-id="element-231" />
              <span className="font-medium text-navy" data-id="element-232">Energía al 10%</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-233">
              <Coffee className="w-8 h-8 text-accent mb-3" data-id="element-234" />
              <span className="font-medium text-navy" data-id="element-235">Dependencia al café</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-236">
              <Brain className="w-8 h-8 text-accent mb-3" data-id="element-237" />
              <span className="font-bold text-navy" data-id="element-238">Niebla mental</span>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-navy/5 flex flex-col items-center text-center" data-id="element-239">
              <Moon className="w-8 h-8 text-accent mb-3" data-id="element-240" />
              <span className="font-medium text-navy" data-id="element-241">
                Agotamiento nocturno
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}